<div class="container">
    <div class="main_content pt-3 mt-2" *ngIf="!!lossRunForm && lossRunForm.controls" pFocusTrap>
        <div class="row m-0">
			<div class="col-lg-6 p-0">
				<div class="font-weight-bold endorsement-group-title">
					<h4 class="mb-1"><b>Loss Run Request</b></h4>
				</div>
			</div>
			<div class="col-lg-6 p-0 text-right">
				<cancel-endorsement [endorsementId]="endorsement.endorsementId"></cancel-endorsement>
			</div>
		</div>
        <form [formGroup]="lossRunForm">
            <div class="mt-4">
                <div class="float-left">
                    <label for="notes">Enter any notes you would like the Berkley Small Business Solutions Underwriter to consider below:</label>
                </div>
                <textarea class="form-control" [pAutoFocus]="true"
                    [class.validate_error_cls]="isSubmitted && lossRunForm.get('notes').invalid" rows="5"
                    formControlName="notes" Name="notes" id="notes"></textarea>
                <div class="col-lg-12 mt-2">
                    <div class="row">
                        <div class="col-md-5 p-0">
                            <label>Please upload supporting documents for this endorsement request</label>
                        </div>
                        <div class="col-md-7 p-0">
                            <endorsement-file-upload-form #fileUploadForm [questionGroup]="endorsementQuestionGroup"
                                toastSummary="Loss Run Request"></endorsement-file-upload-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3 mb-3">
                <div class="col-lg-12">
                    <div class="col-mg-6 p-0 mt-3">
                        <span class="text-lg-left float-lg-left">
                            <modify-endorsement-type [endorsement]="endorsement"></modify-endorsement-type>
                        </span>
                    </div>
                    <endorsement-footer 
                        [parentPage]="this"
                        (clickedViewApplication)="bindAnswersToQuestions()">
                    </endorsement-footer>
                </div>
            </div>
        </form>
    </div>
</div>